import { render } from "./BestWorstBlock.vue?vue&type=template&id=6afcac9e&scoped=true"
import script from "./BestWorstBlock.vue?vue&type=script&lang=js"
export * from "./BestWorstBlock.vue?vue&type=script&lang=js"

import "./BestWorstBlock.vue?vue&type=style&index=0&id=6afcac9e&scoped=true&lang=css"

import exportComponent from "/tmp/build_905a1b4c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6afcac9e"]])

export default __exports__